import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import {
  ContentAnalysisV2Scope,
  ContentTopicsBy,
} from 'src/services/contentAnalysisApi/interfaces/contentAnalysisV2.interface'
import { ContentAnalysisV2ApiService } from 'src/services/contentAnalysisV2Api'

// sm.back answers 20 rows unless asked (200 at most); the table's "View all N
// topics" has to mean all of them.
const TOPICS_LIMIT = 200

export const useGetContentAnalysisTopicsQuery = (
  scope: ContentAnalysisV2Scope,
  by: ContentTopicsBy
) =>
  useQuery({
    placeholderData: keepPreviousData,
    queryFn: () =>
      ContentAnalysisV2ApiService.getTopics(scope, {
        by,
        level: 'topic',
        limit: TOPICS_LIMIT,
      }),
    queryKey: [
      QueryKey.GET_CONTENT_ANALYSIS_TOPICS,
      by,
      scope.analysisIds?.join(','),
      scope.from,
      scope.to,
      scope.period,
      scope.platform,
    ],
  })
